export const FILE_UPLOAD_STATES = {
  INITIAL: 1,
  UPLOADING: 2,
  PROCESSING: 3,
  PROCESSED: 4,
  ERROR: 5,
};

const app_host = process.env.REACT_APP_HOST;
const api_host = process.env.REACT_APP_API_HOST;
export const ENV = process.env.REACT_APP_ENVIRONMENT;
export const CLARITY_ID = process.env.REACT_APP_CLARITY_ID;

export const MAX_FILES = 10;

export const MAX_SUBCONTRACTORS = 5;

export const FEATURES = {
  ENABLE_SIGNUP: process.env.REACT_APP_ENABLE_SIGNUP === 'true',
  CONTACT_EMAIL: process.env.REACT_APP_CONTACT_EMAIL,
};

export const MESSAGES = {
  DEFAULT_ERROR: 'Something went wrong',
};

const concatPath = (base, path) => {
  if (!base || !path) return ''; // Handle undefined or empty inputs
  // Strip trailing slash from base and leading slash from path
  return base.replace(/\/+$/, '') + '/' + path.replace(/^\/+/, '');
};

export const API = {
  host: api_host,
  url: (path) => {
    return concatPath(api_host, path);
  },
};

export const APP = {
  host: app_host,
  url: (path) => {
    return concatPath(app_host, path);
  },
};

export const qsaiImages =
  'https://clink-assets.s3.eu-west-2.amazonaws.com/production/proquo';

// File size limits for uploads
export const FILE_SIZE_LIMITS = {
  // Individual file size limits by type
  PDF: 20 * 1024 * 1024, // 20MB
  EXCEL: 2 * 1024 * 1024, // 2MB
  CSV: 500 * 1024, // 500KB
  TXT: 300 * 1024, // 300KB
  OTHER: 300 * 1024, // 300KB for other file types

  // Maximum individual file size (for any file type)
  MAX_INDIVIDUAL: 20 * 1024 * 1024, // 20MB

  // Maximum total size for all files
  MAX_TOTAL: 50 * 1024 * 1024, // 50MB

  // Warning threshold (80%)
  WARNING_THRESHOLD: 0.8,
};
